import { CompositeScreenProps } from '@react-navigation/native'
import { useTheme } from 'contexts'
import React, { useState } from 'react'
import { Linking, StyleSheet } from 'react-native'

import { EditableUpspaceCover } from 'partials/EditableUpspaceCover'
import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { Separator } from 'widgets/Separator'
import { Text } from 'widgets/Text'
import { TextInput } from 'widgets/TextInput'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'

export const GroupSettingsPage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const theme = useTheme()
  const navigateBack = useNavigateBackOrHome()
  const { data: currentUser } = useCurrentUser()
  const { data: group, updateGroup } = useGroup({ userId: currentUser?.id })

  const [isSaving, setIsSaving] = useState(false)
  const [bioInputText, setBioInputText] = useState(group?.bio ?? '')

  const price = group?.prices ? group?.prices[0]?.original?.unit_amount ?? 0 : 0

  const computeStyles = StyleSheet.create({
    textInput: {
      paddingLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      color: 'black',
      fontSize: theme.fonts.sizes.sm,
    },
  })

  const handleSave = async () => {
    if (!group) return
    setIsSaving(true)
    updateGroup.mutate({
      ...group,
      bio: bioInputText.trim(),
    })
    setIsSaving(false)
    navigateBack()
  }

  const handleChangeUpspacePrice = () => {
    Linking.openURL(
      `https://share.hsforms.com/1Krjcuc5jSFiSeSGMEcn01Acaljb?email=${currentUser?.email}`,
    )
  }

  const handleCreateDiscount = () => {
    Linking.openURL(
      `https://share.hsforms.com/1-FkfVWD_TPWEZhnqzGVZzwcaljb?email=${currentUser?.email}`,
    )
  }

  const saveMenuButton: NavMenuButton = {
    title: 'Save',
    onPress: handleSave,
  }

  return (
    <Page
      isLoading={isSaving}
      withBack
      withScroll
      withNav
      title='Edit Your Group'
      navbarRightButtons={[saveMenuButton]}
      backgroundColor='white'
      navigation={navigation}
    >
      <Box>
        <Separator />

        <Box>
          <EditableUpspaceCover />
        </Box>

        <Separator />

        <Box testID='UpspaceNameContainer' margin={{ top: 'md', horizontal: 'md' }}>
          <Text color='black' bold>
            Group Name
          </Text>

          <Box margin={{ top: 'sm' }}>
            <Text fontSize='sm' color='greyDark'>
              {group?.title ?? 'Not set'}
            </Text>
          </Box>
        </Box>

        <Box testID='UpspaceDescriptionContainer' margin={{ top: 'xl', horizontal: 'md' }}>
          <Box margin={{ horizontal: 'md', bottom: 'smd' }}>
            <Separator />
          </Box>

          <Text color='black' bold>
            Group Description
          </Text>

          <Box margin={{ top: 'sm' }}>
            <TextInput
              multiline
              numberOfLines={5}
              placeholder='150 characters'
              backgroundColor='transparent'
              placeholderTextColor='greyDark'
              onChange={() => setBioInputText}
              value={bioInputText}
              style={computeStyles.textInput}
            />
          </Box>
        </Box>

        {/* <Box testID='PriceContainer' margin={{ top: 'xl', horizontal: 'md' }}>
          <Box margin={{ horizontal: 'md', bottom: 'smd' }}>
            <Separator />
          </Box>
          <Text color='black' bold>
            Price
          </Text>

          <Box
            flexDirection='row'
            justifyContent='space-between'
            align='center'
            margin={{ top: 'sm' }}
          >
            <Text color='greyDark'>{centsToDollars(price)}</Text>
            <Text fontSize='sm' color='greyDark'>
              *14 day free trial for all new members*
            </Text>
          </Box>

          <Box testID='ButtonsContainer' margin={{ vertical: 'xl' }}>
            <BorderButton onPress={handleChangeUpspacePrice} title='Change My Group Price' />
            <Box margin='sm' />
            <BorderButton onPress={handleCreateDiscount} title='Create Discount Code' />
          </Box>
        </Box> */}
      </Box>
    </Page>
  )
}
